export default __webpack_public_path__ + "static/media/avater4.663be6d3.png";